module.exports = __webpack_public_path__ + "quicksilver/static/media/bag-30kg.9e91375a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Baggage/BaggageSelect/img/bag-30kg.svg
// module id = 603
// module chunks = 0